module.exports = {
  src: __webpack_public_path__ + "assets/images/mobile_google.936885e494c600e3.png",
  width: 300,
  height: 96,
  toString: function() { return __webpack_public_path__ + "assets/images/mobile_google.936885e494c600e3.png"; }
};